import { render } from "./ProposalCreateGeneral.vue?vue&type=template&id=9c08ea2c&scoped=true"
import script from "./ProposalCreateGeneral.vue?vue&type=script&lang=js"
export * from "./ProposalCreateGeneral.vue?vue&type=script&lang=js"

import "./ProposalCreateGeneral.vue?vue&type=style&index=0&id=9c08ea2c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c08ea2c"]])

export default __exports__